import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { FileUploader }         from 'ng2-file-upload';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class ManualFuncionamientoService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'manual-funcionamiento'].join('/');
  }

  public save(model: any): Observable<any> {
    let file: FileUploader = model.ruta;

    model.ruta          = this.guid();
    model.tipoarchivo   = file.queue[0].file.type;
    model.nombrearchivo = file.queue[0].file.name;

    return new Observable(observer => {
      super.save(model)
        .subscribe(
          data => {
            file.authToken      = this.auth.getToken();
            file.options.url    = [this.ApiUrl, data.id, 'upload'].join('/');
            file.queue[0].url   = [this.ApiUrl, data.id, 'upload'].join('/');

            file.queue[0].upload();

            file.queue[0]._xhr.onreadystatechange = function(e) {
              if(file.queue[0]._xhr.readyState == 4) {
                observer.next(data);
              }
            }
          },
          error => console.error(error)
        );
    });

    //super.save(model);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/manual-funcionamiento/manual-funcionamiento.service.ts